﻿import React, { useState } from 'react';

import { FormCheckbox, FormHelperText, FormTextInput } from 'components/form-fields';
import { ShowHide } from "components/layout";
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { TagList } from 'components/status';
import { NonIdealState } from '@blueprintjs/core';
import 'components/form-fields/FormFields.css';

export function FormCheckboxList(
    {
        id = null,
        items = [],
        disabled = false,
        loading = false,
        headingText = null,
        dangerHelperText = "",
        grouped = false,
        striped = false,
        searchable = false,
        showTags = false,
        fullWidthSearch = false,
        noDataMessage = "",
        fullWidth = false,
        onChange
    }
) {

    const [searchTerm, setSearchTerm] = useState("");

    function onItemChange(event, idValue) {
        onChange(event, idValue);
    }

    function onSearchChange(item) {
        setSearchTerm(item.target.value);
    }

    function onRemoveItem(event, idValue) {
        onChange(event, idValue);
    }

    const filteredItems = items?.length ? items.filter(function (item) {
        if (searchTerm.length === 0) {
            return true;
        }

        return item.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    }) : [];


    return (
        <div className={classNames("form-field checkbox-list", { "grouped": grouped, "striped": striped })}>
            <ShowHide
                evaluator={headingText != null}
                show={(
                    <h4 className={classNames({ "bp6-skeleton": loading })}>{headingText}</h4>
                )}
            />
            <ShowHide
                evaluator={showTags && items && items.length > 0}
                show={(
                    <TagList items={items == null ? [] :
                        items.filter(function (item) {
                            return item.checked;
                        })} disabled={disabled} onRemoveTag={onRemoveItem} />
                )}
            />
            <ShowHide
                evaluator={searchable}
                show={(
                    <div className="chechbox-list-search">
                        <FormTextInput placeholder="Search" onChange={onSearchChange} value={searchTerm} large disabled={disabled} icon="search" fill={fullWidthSearch} />
                    </div>
                )}
            />
            <div className={`checkbox-list-container ${fullWidth ? 'checkbox-list-container-full-width' : ''}`}>
                {filteredItems.map((item) => {
                    return (
                        <FormCheckbox
                            checked={item.checked}
                            label={item.name}
                            key={item.id}
                            identifier={item.id}
                            onChange={onItemChange}
                            loading={loading}
                            disabled={item.disabled}
                        />
                    );
                })}

                <ShowHide
                    evaluator={!filteredItems.length && !!noDataMessage}
                    show={<NonIdealState
                        title={''}
                        description={noDataMessage}
                    />}
                />
            </div>
            <FormHelperText danger={true}>{dangerHelperText}</FormHelperText>
        </div>
    );
}

FormCheckboxList.propTypes = {
    id: PropTypes.string,
    items: PropTypes.array,
    loading: PropTypes.bool,
    headingText: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    dangerHelperText: PropTypes.string,
    grouped: PropTypes.bool,
    striped: PropTypes.bool,
    searchable: PropTypes.bool,
    showTags: PropTypes.bool,
    fullWidthSearch: PropTypes.bool,
    noDataMessage: PropTypes.string,
    fullWidth: PropTypes.bool
};